var _circle, _path, _line, _circle2, _path2, _line2, _circle3, _path3, _line3, _circle4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 66,
    viewBox: "0 0 537 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#478F96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2239 39V36.86H32.0639V26.94H31.8839L28.8439 30.54L27.2039 29.16L30.6639 25.04H34.6439V36.86H37.8439V39H28.2239Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: 32,
    x2: 139,
    y2: 32,
    stroke: "#478F96",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 33,
    r: 33,
    fill: "#478F96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.324 39H184.644V36.56L189.024 32.72C189.771 32.0667 190.317 31.48 190.664 30.96C191.011 30.4267 191.184 29.8533 191.184 29.24V28.98C191.184 28.3667 190.984 27.9 190.584 27.58C190.184 27.2467 189.697 27.08 189.124 27.08C188.404 27.08 187.857 27.2867 187.484 27.7C187.111 28.1 186.844 28.5867 186.684 29.16L184.404 28.28C184.551 27.8133 184.757 27.3733 185.024 26.96C185.291 26.5333 185.624 26.16 186.024 25.84C186.437 25.52 186.917 25.2667 187.464 25.08C188.011 24.8933 188.637 24.8 189.344 24.8C190.077 24.8 190.731 24.9067 191.304 25.12C191.877 25.32 192.357 25.6067 192.744 25.98C193.144 26.3533 193.444 26.7933 193.644 27.3C193.857 27.8067 193.964 28.36 193.964 28.96C193.964 29.5467 193.871 30.08 193.684 30.56C193.497 31.04 193.244 31.5 192.924 31.94C192.604 32.3667 192.231 32.78 191.804 33.18C191.377 33.5667 190.924 33.96 190.444 34.36L187.504 36.78H194.324V39Z",
    fill: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 241,
    y1: 32,
    x2: 296,
    y2: 32,
    stroke: "#478F96",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 347,
    cy: 33,
    r: 32.5,
    stroke: "#478F96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M345.644 30.68C346.444 30.68 347.031 30.52 347.404 30.2C347.791 29.8667 347.984 29.4467 347.984 28.94V28.8C347.984 28.2267 347.797 27.78 347.424 27.46C347.064 27.1267 346.564 26.96 345.924 26.96C345.311 26.96 344.764 27.1067 344.284 27.4C343.817 27.6933 343.411 28.1067 343.064 28.64L341.384 27.12C341.624 26.8 341.884 26.5 342.164 26.22C342.457 25.9267 342.791 25.68 343.164 25.48C343.537 25.2667 343.957 25.1 344.424 24.98C344.891 24.86 345.417 24.8 346.004 24.8C346.711 24.8 347.351 24.8867 347.924 25.06C348.511 25.22 349.011 25.46 349.424 25.78C349.851 26.1 350.177 26.4867 350.404 26.94C350.631 27.38 350.744 27.88 350.744 28.44C350.744 28.8933 350.671 29.3 350.524 29.66C350.391 30.02 350.197 30.3333 349.944 30.6C349.704 30.8667 349.417 31.0867 349.084 31.26C348.764 31.42 348.424 31.54 348.064 31.62V31.74C348.464 31.82 348.844 31.9467 349.204 32.12C349.564 32.2933 349.871 32.5267 350.124 32.82C350.391 33.1 350.597 33.4333 350.744 33.82C350.904 34.2067 350.984 34.6467 350.984 35.14C350.984 35.7533 350.857 36.3133 350.604 36.82C350.364 37.3267 350.017 37.76 349.564 38.12C349.111 38.48 348.571 38.76 347.944 38.96C347.317 39.1467 346.617 39.24 345.844 39.24C345.164 39.24 344.564 39.1667 344.044 39.02C343.524 38.8867 343.064 38.7 342.664 38.46C342.277 38.22 341.937 37.9467 341.644 37.64C341.351 37.32 341.097 36.9867 340.884 36.64L342.824 35.16C342.984 35.44 343.157 35.7 343.344 35.94C343.531 36.1667 343.744 36.3667 343.984 36.54C344.224 36.7133 344.497 36.8467 344.804 36.94C345.111 37.0333 345.457 37.08 345.844 37.08C346.617 37.08 347.211 36.8933 347.624 36.52C348.037 36.1467 348.244 35.6333 348.244 34.98V34.84C348.244 34.2 348.017 33.7133 347.564 33.38C347.124 33.0467 346.484 32.88 345.644 32.88H344.264V30.68H345.644Z",
    fill: "#478F96"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 398,
    y1: 32,
    x2: 453,
    y2: 32,
    stroke: "#478F96",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 33,
    r: 32.5,
    stroke: "#478F96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M504.364 39V36.3H498.044V34.06L503.604 25.04H506.864V34.26H508.684V36.3H506.864V39H504.364ZM500.204 34.26H504.364V27.6H504.204L500.204 34.26Z",
    fill: "#478F96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.e6851e3074b0002084ffb9af8b657486.svg";
export { ForwardRef as ReactComponent };